<ng-template [ngIf]="actualItinerary">
  <!-- Summary -->
  <div class="d-flex flex-column" style="width: 70%;">
    <!-- Summary Header -->
    <div class="w-100 d-flex align-items-center justify-content-between p-4" style="border: 1px solid #bfbfbf; border-radius: 15px;">
      <h2
        class="mb-0"
        style="
          font-size: 20px;
          font-weight: 500;
          font-family: 'Poppins';
          color: #000000;
          line-height: 1;
        "
      >
        Summary
      </h2>

      <button
        class="maps-results cursor-pointer"
        style="
          max-height: 50px !important;
          height: 40px !important;
          width: 200px;
          font-family: &quot;Rubik&quot;;
          font-size: 14.49px;
          font-weight: 400;
        "
        [ngStyle]="{
          'background-color': mapVisible && '#595959',
          'background-image': !mapVisible ? 'url(/assets/img/app/bg-map.jpg)' : 'none',
          color: mapVisible ? '#FFFFFF' : '#595959'
        }"
        (click)="toggleMap()"
      >
        {{ mapVisible ? "Cerrar Mapa" : "Ver Mapa" }}
      </button>
    </div>

    <!-- Map Viewer -->
    <ng-container *ngIf="mapVisible && mapCoordinates.length > 0">
      <div class="map-container mt-3">
        <app-map-view
          [coordinatesArr]="mapCoordinates"
          [currencies]="currencies"
          [currencyAgency]="currencyAgency"
          [clientSetting]="clientSetting"
          mapMode="route"
          [showPrices]="false"
          [mapHeight]="'315px'"
        >
        </app-map-view>
      </div>
    </ng-container>

    <!-- Summary Content -->
    <ng-container *ngIf="summaryItinerary && summaryItinerary.length > 0">
      <div class="mb-5 d-flex flex-column" style="width: 100%">
        <ng-container *ngFor="let destination of summaryItinerary; let indexDestination = index; let lastDestination = last">
          <ng-container *ngFor="let day of destination.days; let indexDay = index; let last = last">
            <ng-container *ngIf="day.parsedPeriods && day.parsedPeriods.length > 0">

              <!-- Ahora iteramos sobre parsedPeriods que ya es un array -->
              <ng-container *ngFor="let period of day.parsedPeriods; let i = index; let lastParsedPeriods = last">
                <div>
                  <div class="d-flex align-items-center mb-4 mt-5">
                    <!-- Day and title -->
                    <div *ngIf="i === 0" class="row" style="width: 100%; margin: 0;">
                      <div class="col-2 pl-0">
                        <div
                          class="d-flex justify-content-center align-items-center"
                          style="height: 62px;"
                          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                        >
                          <p class="mb-0" style="font-family: &quot;Lato&quot;; font-size: 20px !important; font-weight: 600">
                            {{ getDay(day.day_title) }}
                          </p>
                        </div>
                      </div>

                      <div class="col-10 pr-0">
                        <div
                          class="d-flex justify-content-start align-items-center px-2"
                          style="height: 62px; border: 1px solid #dfdfdf"
                          [ngStyle]="{ color: styleSidebar?.color, 'background-color': '#EFFEF9' }"
                        >
                          <p class="mb-0 ml-4" style="font-family: &quot;Lato&quot;; font-size: 18px !important; font-weight: 600">
                            {{ getDay(day.date) }} | {{ summaryItinerary[indexDestination].city_name }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Welcome Title -->
                  <div *ngIf="indexDay === 0 && i === 0" class="d-flex align-items-center justify-content-between mb-3">
                    <p style="font-family: &quot;Lato&quot;; font-size: 18px; font-weight: 600; margin-bottom: 0px">
                      ¡Bienvenidos a {{ summaryItinerary[indexDestination].city_name }}!
                    </p>
                  </div>

                  <ng-container *ngFor="let item of period.activities; let indexActivity = index; let lastActivity = last">
                    <div
                      *ngIf="i === 0 && indexDay === 0 && indexActivity === 0"
                      class="image-container mb-4"
                      style="width: 100%; height: 200px; border-radius: 12px; overflow: hidden"
                    >
                      <!-- 1) Imagen del propio destino si viene en el summary -->
                      <img
                        *ngIf="summaryItinerary[indexDestination]?.inmg_zones?.length > 0"
                        [src]="summaryItinerary[indexDestination].inmg_zones[0]"
                        alt=""
                        style="width: 100%; height: 100%; object-fit: cover; object-position: center"
                      />

                      <!-- 2) Si no, consultar el endpoint destination-images (solo si devuelve URL) -->
                      <ng-container
                        *ngIf="!(summaryItinerary[indexDestination]?.inmg_zones?.length > 0) && (heroImageFor(indexDestination) | async) as heroImg"
                      >
                        <img
                          *ngIf="heroImg"
                          [src]="heroImg"
                          alt=""
                          style="width: 100%; height: 100%; object-fit: cover; object-position: center"
                        />
                      </ng-container>

                      <!-- 3) Fallback final si ninguna fuente devuelve imagen -->
                      <img
                        *ngIf="
                          !(summaryItinerary[indexDestination]?.inmg_zones?.length > 0) &&
                          !(heroImageFor(indexDestination) | async)
                        "
                        src="../.../../../../../assets/img/app/bg_top_reserva.jpg"
                        alt=""
                        style="width: 100%; height: 100%; object-fit: cover; object-position: center"
                      />
                    </div>

                    <ng-container *ngIf="(item?.activity?.item && item?.activity?.category_id) || item?.activity?.suggestionIA">
                      <!-- Insurance ACTIVA: se muestra ANTES del primer label del día en un collapsible -->
                      <ng-container *ngIf="i === 0 && indexActivity === 0 && day._insurancesActive && day._insurancesActive.length > 0">
                        <div class="row m-0" style="margin-bottom: 20px !important;">
                          <div class="col-2 pl-0">
                            <div class="d-flex flex-column align-items-center adjust-container-icon-line">
                              <span class="icon-line">
                                <span class="container-icon d-flex justify-content-center align-items-center" style="background-color: #effef9">
                                  <img width="30px" src="../../../assets/img/app/categories-search-box/icon-seguro.svg" />
                                </span>
                              </span>
                            </div>
                          </div>
                          <div class="col-10 pr-0">
                            <div class="d-flex flex-column">
                              <!-- Collapsible Header -->
                              <div class="insurance-collapsible-header" (click)="toggleInsurances(day)"
                                  style="background-color: #EFFEF9; border: 1px solid #ababab; border-radius: 5px; height: 60px; cursor: pointer; display: flex; align-items: center; justify-content: space-between; padding: 0 25px; position: relative;">
                                <div class="d-flex align-items-center" style="gap: 15px;">
                                  <h3 style="font-size: 18px; font-family: 'Lato'; font-weight: 600; color: #000000; margin-bottom: 0;">
                                    Tu asistencia al viajero está <span style="color: #28a745; font-weight: 700;">activa</span>
                                  </h3>
                                  <div class="d-flex align-items-center" style="gap: 10px;">
                                    <ng-container *ngFor="let insurance of day._insurancesActive">
                                      <div class="d-flex align-items-center justify-content-center" style="background-color: #FFFFFF; border: 1px solid #ababab; border-radius: 50%; width: 40px; height: 40px; padding: 5px;">
                                        <img style="width: 100%; height: 100%; object-fit: contain;" [src]="insurance?.item?.provider?.logo" alt="" />
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>

                                <img
                                  width="10px"
                                  src="../../../../../../../assets/img/app/little-icons/arrow-down-black.svg"
                                  alt=""
                                  style="cursor: pointer; transition: transform 0.3s ease;"
                                  [style.transform]="day._insurancesExpanded ? 'rotate(0deg)' : 'rotate(180deg)'"
                                />
                              </div>

                              <!-- Collapsible Content -->
                              <div *ngIf="day._insurancesExpanded" class="insurance-collapsible-content" style="background-color: #FFFFFF;
                              border-left: 1px solid #ababab; border-right: 1px solid #ababab; border-bottom: 1px solid #ababab; margin-top:
                              -6px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; padding-top: 6px;">
                                <div
                                  *ngFor="let ins of day._insurancesActive; let isLast = last"
                                  [style.border-bottom]="!isLast ? '1px solid #ababab' : 'none'"
                                  style="padding: 15px 20px;"
                                >
                                  <div class="d-flex align-items-center" style="gap: 25px;">
                                    <img style="width: 80px; height: 60px; object-fit: contain;" [src]="ins.item.images[0]" alt="" />

                                    <div class="d-flex flex-column justify-content-center" style="flex: 1;">
                                      <h4 style="font-size: 18px; font-family: 'Lato'; font-weight: 600; color: #000000; margin-bottom: 0;">
                                        Asistencia al viajero {{ ins.item.title }} está
                                        <span style="color: #28a745">
                                          activa
                                        </span>
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <div class="row m-0">
                        <div class="col-2 pl-0">
                          <div
                            *ngIf="indexActivity === 0"
                            class="px-4 rounded-pill d-flex justify-content-center align-items-center py-1 mb-4 mt-1"
                            [ngStyle]="{
                              'margin-top':
                                item?.activity?.form?.destination?.inmg_zone && item?.activity?.form?.destination?.inmg_zones?.length > 0
                                  ? '2em'
                                  : ''
                            }"
                            style="background-color: #ebebec; border: 1px solid #9b9b9b"
                          >
                            <p style="font-family: &quot;Rubik&quot;, serif; font-size: 15px; font-weight: 400; margin-bottom: 0px">
                              <ng-container>{{ period.label }}</ng-container>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="row m-0">
                        <div class="col-2 pl-0" style="position: relative;">
                          <div class="d-flex align-items-center justify-content-center" style="position: absolute; width: 100%; height: 100%; padding-right: 15px; z-index: 0;">
                            <div style="width: 1px; height: 100%; background-color: #818181;"></div>
                          </div>

                          <div class="d-flex flex-column align-items-center adjust-container-icon-line" style="position: relative;">
                            <span class="icon-line" style="width: 60px; height: 60px;">
                              <span class="container-icon d-flex justify-content-center align-items-center">
                                <img
                                  width="30px"
                                  src="../../../assets/icons/itinerary/bed-svgrepo-com.svg"
                                  *ngIf="getItem(item.activity).categoryName == categoryName.Hotels"
                                />
                                <img
                                  width="30px"
                                  src="../../../assets/icons/itinerary/school_15476203.svg"
                                  *ngIf="getItem(item.activity).categoryName == categoryName.Transports"
                                />
                                <img
                                  width="30px"
                                  src="../../../assets/img/app/categories-search-box/road-map.svg"
                                  *ngIf="
                                    getItem(item.activity).categoryName == categoryName.Tours && getItem(item.activity).subCategoryId === 6
                                  "
                                />
                                <img
                                  width="30px"
                                  src="../../../assets/img/app/categories-search-box/combi-ticket.svg"
                                  *ngIf="
                                    getItem(item.activity).categoryName == categoryName.Tours && getItem(item.activity).subCategoryId === 9
                                  "
                                />
                                <img
                                  width="30px"
                                  src="../../../assets/img/app/categories-search-box/icon-seguro.svg"
                                  *ngIf="getItem(item.activity).categoryName == categoryName.Insurance"
                                />
                                <img
                                  width="30px"
                                  src="../../../assets/img/app/categories-search-box/car-compact.svg"
                                  *ngIf="getItem(item.activity).categoryName == categoryName.Rentacar"
                                />
                                <img
                                  width="30px"
                                  src="../../../assets/img/app/categories-search-box/AEREO.svg"
                                  *ngIf="getItem(item.activity).categoryName == categoryName.Flights"
                                />
                                <img
                                  width="30px"
                                  src="../../../assets/img/app/categories-search-box/boat.svg"
                                  *ngIf="getItem(item.activity).categoryName == categoryName.Boats"
                                />
                              </span>
                            </span>
                          </div>
                        </div>

                        <div class="col-10 pr-0">
                          <!-- Hotel -->
                          <ng-template [ngIf]="getItem(item.activity).categoryName == categoryName.Hotels">
                            <div class="d-flex flex-column mb-3">
                              <usb-item-hotel
                                [dato]="getItem(item.activity)"
                                [rooms]="getHotelRooms(item.activity)"
                                [isStayRepeat]="!!item.activity._isStayRepeat"
                                [permissions]="permissions"
                                (delete)="deleteItem($event)"
                                [isCheckIn]="!item.activity.ckeckout"
                                [clientSetting]="clientSetting"
                                [currencies]="currencies"
                                [currencyAgency]="currencyAgency"
                                (itemDelete)="_removeItem($event)"
                                (cancel)="cancelIReserve($event)"
                                (itemToPartial)="_itemToPartial($event)"
                                [partialReserve]="partialReserve"
                              >
                              </usb-item-hotel>
                            </div>
                          </ng-template>

                          <!-- Traslado -->
                          <ng-template [ngIf]="getItem(item.activity).categoryName == categoryName.Transports">
                            <div class="d-flex flex-column mb-3">
                              <div
                                class="row mb-4"
                                *ngIf="
                                  indexDay === 0 &&
                                  item?.formTransport?.firstOrigin?.img_zones &&
                                  item?.formTransport?.firstOrigin?.img_zones.length > 0
                                "
                              >
                                <div style="width: 100%">
                                  <div
                                    class="row"
                                    style="height: 180px; border-radius: 12px; width: 100%;
                                        background-image: url('{{ item?.formTransport?.firstOrigin?.img_zones[0] }}');
                                        background-size: 100%;
                                        background-position: center;
                                        background-repeat: no-repeat;
                                        margin-left: -10px"
                                  >
                                    <!-- <img class="col-12 img-fluid " src="{{item.activity.form.destination.inmg_zones[0]}}" alt=""> -->
                                  </div>
                                </div>
                              </div>
                              <usb-item-transport
                                [data]="getItem(item.activity)"
                                [permissions]="permissions"
                                [isCheckIn]="!item.activity.ckeckout"
                                (delete)="deleteItem($event)"
                                [partialReserve]="partialReserve"
                                [currencies]="currencies"
                                [clientSetting]="clientSetting"
                                [currencyAgency]="currencyAgency"
                                (cancel)="cancelIReserve($event)"
                                (itemDelete)="_removeItem($event)"
                                (itemToPartial)="_itemToPartial($event)"
                                (editItem)="_editItem($event)"
                              >
                              </usb-item-transport>
                            </div>
                          </ng-template>

                          <ng-template [ngIf]="getItem(item.activity).categoryName == categoryName.Tours">
                            <div class="d-flex flex-column mb-3">
                              <usb-item-tours
                                [permissions]="permissions"
                                [dato]="getItem(item.activity)"
                                [isCheckIn]="!item.activity.ckeckout"
                                [partialReserve]="partialReserve"
                                [currencies]="currencies"
                                (delete)="deleteItem($event)"
                                (cancel)="cancelIReserve($event)"
                                [clientSetting]="clientSetting"
                                [currencyAgency]="currencyAgency"
                                (reSearch)="reSearch($event)"
                                (itemToPartial)="_itemToPartial($event)"
                                (itemDelete)="_removeItem($event)"
                                (editItem)="_editItem($event)"
                              >
                              </usb-item-tours>
                            </div>
                          </ng-template>

                          <ng-template [ngIf]="getItem(item.activity).categoryName == categoryName.Rentacar">
                            <usb-item-rentacar
                              (delete)="deleteItem($event)"
                              (cancel)="cancelIReserve($event)"
                              [dato]="getItem(item.activity)"
                              [currencies]="currencies"
                              [clientSetting]="clientSetting"
                              [currencyAgency]="currencyAgency"
                              [partialReserve]="partialReserve"
                              (itemToPartial)="_itemToPartial($event)"
                              [permissions]="permissions"
                              [isCheckIn]="!item.activity.ckeckout"
                              [isCheckOut]="item.activity.ckeckout"
                            >
                            </usb-item-rentacar>
                          </ng-template>

                          <ng-template [ngIf]="getItem(item.activity).categoryName == categoryName.Disney">
                            <usb-item-disney
                              [dato]="getItem(item.activity)"
                              [isCheckIn]="!item.activity.ckeckout"
                              [partialReserve]="partialReserve"
                              (itemToPartial)="_itemToPartial($event)"
                            >
                            </usb-item-disney>
                          </ng-template>

                          <ng-template [ngIf]="getItem(item.activity).categoryName == categoryName.Ptheme">
                            <usb-item-pthemes
                              [dato]="getItem(item.activity)"
                              [partialReserve]="partialReserve"
                              (itemToPartial)="_itemToPartial($event)"
                              [isCheckIn]="!item.activity.ckeckout"
                            >
                            </usb-item-pthemes>
                          </ng-template>

                          <ng-template [ngIf]="getItem(item.activity).categoryName == categoryName.Insurance">
                            <div class="d-flex flex-column">
                              <usb-item-insurance
                                [dato]="getItem(item.activity)"
                                [permissions]="permissions"
                                [isCheckIn]="!item.activity.ckeckout"
                                (delete)="deleteItem($event)"
                                [partialReserve]="partialReserve"
                                [currencies]="currencies"
                                [clientSetting]="clientSetting"
                                [currencyAgency]="currencyAgency"
                                (cancel)="cancelIReserve($event)"
                                (itemDelete)="_removeItem($event)"
                                (itemToPartial)="_itemToPartial($event)"
                                (editItem)="_editItem($event)"
                                [isCheckIn]="!item.activity.ckeckout"
                              >
                              </usb-item-insurance>
                            </div>
                          </ng-template>

                          <ng-template [ngIf]="getItem(item.activity).categoryName == categoryName.Flights">
                            <div class="d-flex flex-column mb-3">
                              <usb-item-flight
                                [dato]="getItem(item.activity)"
                                [permissions]="permissions"
                                [isCheckIn]="!item.activity.ckeckout"
                                (delete)="deleteItem($event)"
                                [partialReserve]="partialReserve"
                                [currencies]="currencies"
                                (cancel)="cancelIReserve($event)"
                                [clientSetting]="clientSetting"
                                [currencyAgency]="currencyAgency"
                                (itemToPartial)="_itemToPartial($event)"
                                (itemDelete)="_removeItem($event)"
                              >
                              </usb-item-flight>
                            </div>
                          </ng-template>

                          <ng-template [ngIf]="getItem(item.activity).categoryName == categoryName.Boats">
                            <div class="d-flex flex-column mb-3">
                              <usb-item-boat
                                [dato]="getItem(item.activity)"
                                [permissions]="permissions"
                                [isCheckIn]="!item.activity.is_departure"
                                (delete)="deleteItem($event)"
                                [partialReserve]="partialReserve"
                                [currencies]="currencies"
                                (cancel)="cancelIReserve($event)"
                                [clientSetting]="clientSetting"
                                [currencyAgency]="currencyAgency"
                              >
                              </usb-item-boat>
                            </div>
                          </ng-template>

                          <ng-template #withoutCategory>
                            <usb-item-disney class="col-12"></usb-item-disney>
                            <usb-item-rentacar class="col-12"></usb-item-rentacar>
                            <usb-item-pthemes class="col-12"></usb-item-pthemes>
                          </ng-template>
                        </div>
                      </div>

                    <!-- Sugerencias por fecha — debajo de la primera actividad del día -->
                    <!-- TODO: En el futuro, asignar sugerencias según su propio período cuando el endpoint provea esa info -->
                    <ng-container *ngIf="i === 0 && indexActivity === 0 && day.dateSuggestions && day.dateSuggestions.length > 0">
                      <div class="row m-0">
                        <div class="col-2 pl-0" style="position: relative;">
                          <div class="d-flex align-items-center justify-content-center" style="position: absolute; width: 100%; height: 100%; padding-right: 15px; z-index: 0;">
                            <div style="width: 1px; height: 100%; background-color: #818181;"></div>
                          </div>
                        </div>

                        <div class="col-10 pr-0">
                          <div class="d-flex flex-column">
                            <usb-suggestions-item
                              class="d-flex justify-content-between align-items-start mt-4 mb-4"
                              style="width: 100%"
                              [suggestions]="day.dateSuggestions"
                              [currencyAgency]="currencyAgency"
                              [currencies]="currencies"
                              [clientSetting]="getClientsSettingAppBooking"
                              [paymentAgencyActive]="paymentAgencyActive"
                              (reloadEmmit)="suggestionAdd()"
                            >
                            </usb-suggestions-item>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                      <ng-container *ngIf="lastActivity && last && lastParsedPeriods">
                        <!-- Insurance FINALIZÓ: se muestra DESPUÉS del checkout del día en un collapsible -->
                        <ng-container *ngIf="day._insurancesEnded && day._insurancesEnded.length > 0">
                          <div class="row m-0">
                            <div class="col-2 pl-0">
                              <div class="d-flex flex-column align-items-center adjust-container-icon-line">
                                <span class="icon-line">
                                  <span class="container-icon d-flex justify-content-center align-items-center" style="background-color: #ffd9e0">
                                    <svg version="1.1" id="outline" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 600 612.4" style="fill: #fe2e54; width: 30px; height: 30px; enable-background:new 0 0 600 612.4;" xml:space="preserve"> <g> <path d="M599.4,237.2c0,8.6,0,17.2,0,25.7c-0.8,7.1-1.5,14.3-2.6,21.3C585.6,355.8,550,412,490.2,452.9c-1.7,1.1-3.3,2.4-5.1,3.6 c1.1,1.2,1.9,2.1,2.7,2.9c22,22.9,21.8,54.1-0.6,76.7c-9.7,9.8-19.4,19.7-29.4,29.3c-17.7,16.9-38.2,28.7-62,34.7 c-9.2,2.3-18.6,3.7-27.9,5.5c-9.7,0-19.5,0-29.2,0c-0.9-0.3-1.8-0.8-2.7-0.9c-37.3-3.3-71.8-15.6-104.4-33.2 C162,534.3,105.8,482.1,60.8,417.7C35.3,381.2,15.5,341.9,5.9,298c-2.4-10.8-3.6-21.8-5.4-32.7c0-7.8,0-15.6,0-23.4 c0.4-1.9,0.9-3.7,1.1-5.6c2.7-28,11.5-53.9,29.5-75.5c13.7-16.4,28.7-31.8,44.6-46.2c19.5-17.7,49.3-16.2,68.8,1.6 c1.6,1.5,3.3,3,5.1,4.7c1.3-1.9,2.2-3.1,3-4.4c38.2-56.4,90.4-91.7,157.3-105.2c9.5-1.9,19.1-3,28.7-4.5c11.3,0,22.6,0,33.9,0 c1.3,0.3,2.6,0.8,3.9,0.9c28.4,2.2,55.7,9,81.3,21.5c74.5,36.3,120.7,94.9,137.2,176.4C597.1,216,598,226.7,599.4,237.2z M338.3,42.6c-4.5,0.5-8.2,0.9-11.8,1.4C262,54,212.6,86.9,177.9,142c-2.4,3.8-1.8,5.9,1.3,8.7c7.8,7.4,15.4,14.9,22.8,22.7 c19.6,20.7,19.6,51.6,0.1,72.4c-3.5,3.7-7.1,7.2-10.7,10.8c-8.9,8.9-13.5,19.8-12.7,32.2c0.6,9,2.2,18.2,5.2,26.8 c10.2,29.3,29,52.7,51.9,73c19.3,17.1,40.4,31.1,66,37.2c19.8,4.7,37.5,1.7,51.6-14.4c1.8-2,3.8-3.9,5.8-5.8 c21.8-21.1,53.3-21.1,75,0.1c7.1,6.9,14.2,13.9,21,21.1c2.9,3.1,5,3.6,8.8,1.2c47.1-29.3,78.4-70.5,93-124 c3.2-11.7,4.7-23.8,7.2-36.6c-16.4,0-31.3,0-46.5,0c0-11.9,0-23.3,0-35.1c15.3,0,30.3,0,45.2,0C556,126,462.5,46.6,373.4,43.6 c0,14.9,0,29.8,0,44.7c-12,0-23.4,0-35.1,0C338.3,73.1,338.3,58.3,338.3,42.6z M347.9,570.5c38.8,0.2,66.3-11.1,90.2-34.8 c8-8,16-16,24-24c9.4-9.4,9.4-19.1-0.1-28.6c-16.5-16.6-33.1-33.1-49.6-49.6c-11.5-11.5-19.9-11.5-31.4,0.1 c-8.8,8.9-17.9,17.3-29.6,22.4c-20.9,9.1-42.4,9.5-63.4,2.3c-67.6-23.2-113.5-69.2-138.7-135.7c-7.5-19.9-8.4-40.7-1.5-61.3 c4.9-14.5,14.5-25.6,25.2-36c11.5-11.2,11.4-19.9-0.1-31.4c-16.7-16.7-33.4-33.4-50.1-50c-9.1-9-18.5-8.9-27.7,0 c-8.5,8.3-16.8,16.9-25.2,25.2c-23,22.7-33.9,50.5-34.1,82.5c-0.2,33.4,9.2,64.8,24,94.3c44.2,88.2,110.7,154.7,198.5,199.5 C287.8,560.7,319.3,570.1,347.9,570.5z"/> <path d="M432,185.7c0,27,0,53,0,79.6c4.9,0,9.3,0,14,0c0,8.6,0,16.7,0,25.4c-4.7,0-9,0-14.1,0c0,8.5,0,16.4,0,24.7 c-9.1,0-17.5,0-26.5,0c0-8.1,0-16,0-24.5c-17.2,0-33.9,0-50.9,0c-0.6-6.7-1.2-12.5,2.3-18.4c15.9-27.2,31.5-54.6,47-82 c2-3.6,4.2-4.9,8.2-4.7C418.4,186,424.8,185.7,432,185.7z M405,239.2c-0.3-0.1-0.6-0.2-0.9-0.3c-4.7,8.5-9.5,17-14.5,26 c5.8,0,10.6,0,15.5,0C405,256,405,247.6,405,239.2z"/> <path d="M307.2,290.7c14,0,27.4,0,41.1,0c0,8.5,0,16.3,0,24.6c-27.6,0-54.9,0-82.5,0c-0.9-7.6-0.9-14.2,4.5-20.7 c14.4-17.4,28-35.5,41.8-53.3c4.3-5.6,8.3-11.3,7.8-19c-0.4-7.1-3.3-11.2-9.2-12.3c-6.9-1.3-12.8,1.4-15.2,7.8 c-1.5,3.9-1.9,8.2-3,12.9c-7.5-1.4-14.9-2.6-22.3-4.3c-1.1-0.2-2.4-2.4-2.4-3.6c-0.4-22.7,18.9-39.6,43.5-38.3 c22.1,1.1,37.3,19.3,34.9,41.8c-1.1,10.2-5.2,19-11.5,27c-9.1,11.7-18.1,23.5-27.1,35.2C307.6,288.9,307.6,289.3,307.2,290.7z"/> </g> </svg>
                                  </span>
                                </span>
                              </div>
                            </div>
                            <div class="col-10 pr-0">
                              <div class="d-flex flex-column w-100">
                                <!-- Collapsible Header -->
                                <div class="insurance-collapsible-header"
                                    style="background-color: #ffd9e0; border: 1px solid #ababab; border-radius: 10px; height: 90px; cursor: pointer; display: flex; align-items: center; justify-content: space-between; padding: 0px 25px;">
                                  <div class="d-flex align-items-center w-100" style="gap: 15px;">
                                    <h3 style="font-size: 18px; font-family: 'Lato'; font-weight: 600; color: #000000; margin-bottom: 0;">
                                      Tu asistencia al viajero <span style="color: #fe2e54; font-weight: 700;">finalizó</span>
                                    </h3>
                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                      <ng-container *ngFor="let insurance of day._insurancesEnded">
                                        <div class="d-flex align-items-center justify-content-center" style="background-color: #FFFFFF; border: 1px solid #ababab; border-radius: 50%; width: 40px; height: 40px; padding: 5px;">
                                          <img style="width: 100%; height: 100%; object-fit: contain;" [src]="insurance?.item?.provider?.logo" alt="" />
                                        </div>
                                      </ng-container>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                      <div *ngIf="!lastDestination && lastActivity && last" class="d-flex align-items-center justify-content-center">
                        <hr class="separator mt-5" />
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>

             <!-- Día libre (sin servicios) -->
             <ng-container *ngIf="day.isFreeDay">
               <div class="d-flex align-items-center mb-4 mt-5">
                 <div class="row m-0" style="width: 100%; margin: 0;">
                  <div class="col-2 pl-0">
                    <div
                      class="d-flex justify-content-center align-items-center"
                      style="height: 62px;"
                      [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                    >
                      <p class="mb-0" style="font-family: &quot;Lato&quot;; font-size: 20px !important; font-weight: 600">
                        {{ getDay(day.day_title) }}
                      </p>
                    </div>
                  </div>
                  <div class="col-10 pr-0">
                    <div
                      class="d-flex justify-content-start align-items-center px-2"
                      style="height: 62px; border: 1px solid #dfdfdf"
                      [ngStyle]="{ color: styleSidebar?.color, 'background-color': '#EFFEF9' }"
                    >
                      <p class="mb-0 ml-4" style="font-family: &quot;Lato&quot;; font-size: 18px !important; font-weight: 600">
                        {{ getDay(day.date) }} | {{ summaryItinerary[indexDestination].city_name }}
                      </p>
                    </div>
                  </div>
                 </div>
               </div>

               <!-- Insurance ACTIVA en día libre -->
               <ng-container *ngIf="day._insurancesActive && day._insurancesActive.length > 0">
                 <div *ngFor="let insActive of day._insurancesActive" class="row m-0">
                  <div class="col-2 pl-0">
                    <div class="d-flex flex-column align-items-center adjust-container-icon-line">
                      <span class="icon-line">
                        <span class="container-icon d-flex justify-content-center align-items-center" style="background-color: #EFFEF9;">
                          <img width="30px" src="../../../assets/img/app/categories-search-box/icon-seguro.svg" />
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-10 pr-0">
                   <div class="d-flex flex-column">
                     <usb-item-insurance
                       [dato]="insActive"
                       [isEnded]="false"
                       [currencies]="currencies"
                       [currencyAgency]="currencyAgency"
                       [clientSetting]="clientSetting"
                       [isCheckIn]="true"
                     >
                     </usb-item-insurance>
                   </div>
                  </div>
                 </div>
               </ng-container>

                <!-- Día Libre box (siempre visible) — icono mapa -->
                <div *ngIf="!day._breakfastInfo?.hasBreakfast && !day._isCheckoutDay" class="row m-0">
                  <div class="col-2 pl-0">
                    <div class="d-flex flex-column align-items-center adjust-container-icon-line">
                      <span class="icon-line">
                        <span class="container-icon d-flex justify-content-center align-items-center" style="background-color: #FFD9E0;">
                            <svg style="width: 30px; height: 30px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 612.44"><g id="Layer_2" data-name="Layer 2"><path d="M347.31,331.36a28.59,28.59,0,0,0-12.37,7.12c-16.33,15.84-32.26,32.09-48.8,48.67-7.79-7.83-15-15-22.16-22.28-4.38-4.43-9.53-6.93-15.85-6.05-7,1-12,4.76-14.4,11.45-2.59,7.14-1,13.59,4.26,19q16.74,17,33.71,33.73c9.73,9.66,19.31,9.58,29.14-.21q22.1-22,44.13-44.12c6-6,12.06-11.81,17.8-18a17.64,17.64,0,0,0,2.69-20.24C361.92,333.76,354.75,329.54,347.31,331.36Z"/><path d="M536.9,41.31H505.76V21.6a17.5,17.5,0,0,0-35,0V41.31h-35V21.6a17.5,17.5,0,0,0-35,0V41.31h-199V21.6a17.5,17.5,0,1,0-35,0V41.31h-35V21.6a17.5,17.5,0,1,0-35,0V41.31H63.1A57.9,57.9,0,0,0,5.26,99.15V550.5A57.9,57.9,0,0,0,63.1,608.34H536.9a57.9,57.9,0,0,0,57.84-57.84V99.15A57.9,57.9,0,0,0,536.9,41.31Zm-473.8,35H96.76V97a17.5,17.5,0,1,0,35,0V76.31h35V97a17.5,17.5,0,0,0,35,0V76.31h199V97a17.5,17.5,0,1,0,35,0V76.31h35V97a17.5,17.5,0,1,0,35,0V76.31H536.9a22.83,22.83,0,0,1,22.84,22.84v54.63H40.26V99.15A22.83,22.83,0,0,1,63.1,76.31Zm473.8,497H63.1A22.83,22.83,0,0,1,40.26,550.5V188.78H559.74V550.5A22.83,22.83,0,0,1,536.9,573.34Z"/><path d="M301.19,239.65c-77.36,0-140.3,62.94-140.3,140.3s62.94,140.31,140.3,140.31S441.5,457.32,441.5,380,378.56,239.65,301.19,239.65Zm0,245.61A105.31,105.31,0,1,1,406.5,380,105.42,105.42,0,0,1,301.19,485.26Z"/></g></svg>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-10 pr-0">
                    <div class="d-flex flex-column justify-content-center mt-1 mb-4">
                      <div class="d-flex align-items-center" style="gap: 35px;">
                        <div class="w-100" style="background-color: #FFEBF0; border-radius: 4px; border: 1px solid #bfbfbf; padding: 14px 25px;">
                          <h3 style="
                            font-size: 17px;
                            font-family: 'Poppins';
                            font-weight: 600;
                            color: #000000;
                            line-height: 1.2;
                            margin-bottom: 0;
                          ">
                            Día Libre.
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
               </div>

                <div *ngIf="day._isCheckoutDay" class="row m-0">
                  <div class="col-2 pl-0">
                    <div class="d-flex flex-column align-items-center adjust-container-icon-line">
                      <span class="icon-line">
                        <span class="container-icon d-flex justify-content-center align-items-center" style="background-color: #FFD9E0;">
                            <svg fill="#fe2e54" width="30px" height="30px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M5 10C3.355469 10 2 11.355469 2 13L2 28.1875C2.003906 28.25 2.015625 28.3125 2.03125 28.375C2.03125 28.386719 2.03125 28.394531 2.03125 28.40625C1.582031 29.113281 1.214844 29.867188 0.9375 30.6875C0.316406 32.519531 0.0507813 34.621094 0 37L0 38C0 38.03125 0 38.0625 0 38.09375L0 50L7 50L7 46C7 45.167969 7.203125 44.734375 7.46875 44.46875C7.734375 44.203125 8.167969 44 9 44L41 44C41.832031 44 42.265625 44.203125 42.53125 44.46875C42.796875 44.734375 43 45.167969 43 46L43 50L50 50L50 38.15625C50.003906 38.105469 50.003906 38.050781 50 38C50 37.65625 50.007813 37.332031 50 37C49.949219 34.621094 49.683594 32.519531 49.0625 30.6875C48.785156 29.875 48.414063 29.136719 47.96875 28.4375C47.988281 28.355469 48 28.273438 48 28.1875L48 13C48 11.355469 46.644531 10 45 10 Z M 5 12L45 12C45.5625 12 46 12.4375 46 13L46 26.15625C45.753906 25.949219 45.492188 25.75 45.21875 25.5625C44.550781 25.101563 43.824219 24.671875 43 24.3125L43 20C43 19.296875 42.539063 18.75 42.03125 18.40625C41.523438 18.0625 40.902344 17.824219 40.125 17.625C38.570313 17.226563 36.386719 17 33.5 17C30.613281 17 28.429688 17.226563 26.875 17.625C26.117188 17.820313 25.5 18.042969 25 18.375C24.5 18.042969 23.882813 17.820313 23.125 17.625C21.570313 17.226563 19.386719 17 16.5 17C13.613281 17 11.429688 17.226563 9.875 17.625C9.097656 17.824219 8.476563 18.0625 7.96875 18.40625C7.460938 18.75 7 19.296875 7 20L7 24.3125C6.175781 24.671875 5.449219 25.101563 4.78125 25.5625C4.507813 25.75 4.246094 25.949219 4 26.15625L4 13C4 12.4375 4.4375 12 5 12 Z M 16.5 19C19.28125 19 21.34375 19.234375 22.625 19.5625C23.265625 19.726563 23.707031 19.925781 23.90625 20.0625C23.988281 20.117188 23.992188 20.125 24 20.125L24 22C17.425781 22.042969 12.558594 22.535156 9 23.625L9 20.125C9.007813 20.125 9.011719 20.117188 9.09375 20.0625C9.292969 19.925781 9.734375 19.726563 10.375 19.5625C11.65625 19.234375 13.71875 19 16.5 19 Z M 33.5 19C36.28125 19 38.34375 19.234375 39.625 19.5625C40.265625 19.726563 40.707031 19.925781 40.90625 20.0625C40.988281 20.117188 40.992188 20.125 41 20.125L41 23.625C37.441406 22.535156 32.574219 22.042969 26 22L26 20.125C26.007813 20.125 26.011719 20.117188 26.09375 20.0625C26.292969 19.925781 26.734375 19.726563 27.375 19.5625C28.65625 19.234375 30.71875 19 33.5 19 Z M 24.8125 24C24.917969 24.015625 25.019531 24.015625 25.125 24C25.15625 24 25.1875 24 25.21875 24C35.226563 24.015625 41.007813 25.0625 44.09375 27.1875C45.648438 28.257813 46.589844 29.585938 47.1875 31.34375C47.707031 32.875 47.917969 34.761719 47.96875 37L2.03125 37C2.082031 34.761719 2.292969 32.875 2.8125 31.34375C3.410156 29.585938 4.351563 28.257813 5.90625 27.1875C8.992188 25.058594 14.785156 24.011719 24.8125 24 Z M 2 39L48 39L48 48L45 48L45 46C45 44.832031 44.703125 43.765625 43.96875 43.03125C43.234375 42.296875 42.167969 42 41 42L9 42C7.832031 42 6.765625 42.296875 6.03125 43.03125C5.296875 43.765625 5 44.832031 5 46L5 48L2 48Z"/></svg>
                        </span>
                      </span>
                    </div>
                  </div>

                  <div class="col-10 pr-0">
                    <div class="d-flex flex-column justify-content-center mt-1 mb-4" style="padding: 15px 0px;">
                      <div class="d-flex align-items-center" style="gap: 30px;">
                        <div class="w-100">
                          <h3 style="
                            font-size: 18px;
                            font-family: 'Rubik';
                            font-weight: 500;
                            color: #000000;
                            line-height: 1.2;
                            margin-bottom: 0;
                          ">
                              <span style="color: #fe2e54; font-weight: 600;">Check-Out</span> {{ day._checkoutHotelInfo?.title }} <span *ngIf="day._checkoutHotelInfo?.time" style="font-weight: 600;">{{day._checkoutHotelInfo?.time}} hs.</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
               </div>

                <!-- Si tiene desayuno -->
                <div *ngIf="day._breakfastInfo?.hasBreakfast && !day._isCheckoutDay" class="row m-0">
                  <div class="col-2 pl-0">
                    <div class="d-flex flex-column align-items-center adjust-container-icon-line">
                      <span class="icon-line">
                        <span class="container-icon d-flex justify-content-center align-items-center" style="background-color: #FFD9E0;">
                            <svg style="width: 30px; height: 30px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 612.44"><g id="Layer_2" data-name="Layer 2"><path d="M347.31,331.36a28.59,28.59,0,0,0-12.37,7.12c-16.33,15.84-32.26,32.09-48.8,48.67-7.79-7.83-15-15-22.16-22.28-4.38-4.43-9.53-6.93-15.85-6.05-7,1-12,4.76-14.4,11.45-2.59,7.14-1,13.59,4.26,19q16.74,17,33.71,33.73c9.73,9.66,19.31,9.58,29.14-.21q22.1-22,44.13-44.12c6-6,12.06-11.81,17.8-18a17.64,17.64,0,0,0,2.69-20.24C361.92,333.76,354.75,329.54,347.31,331.36Z"/><path d="M536.9,41.31H505.76V21.6a17.5,17.5,0,0,0-35,0V41.31h-35V21.6a17.5,17.5,0,0,0-35,0V41.31h-199V21.6a17.5,17.5,0,1,0-35,0V41.31h-35V21.6a17.5,17.5,0,1,0-35,0V41.31H63.1A57.9,57.9,0,0,0,5.26,99.15V550.5A57.9,57.9,0,0,0,63.1,608.34H536.9a57.9,57.9,0,0,0,57.84-57.84V99.15A57.9,57.9,0,0,0,536.9,41.31Zm-473.8,35H96.76V97a17.5,17.5,0,1,0,35,0V76.31h35V97a17.5,17.5,0,0,0,35,0V76.31h199V97a17.5,17.5,0,1,0,35,0V76.31h35V97a17.5,17.5,0,1,0,35,0V76.31H536.9a22.83,22.83,0,0,1,22.84,22.84v54.63H40.26V99.15A22.83,22.83,0,0,1,63.1,76.31Zm473.8,497H63.1A22.83,22.83,0,0,1,40.26,550.5V188.78H559.74V550.5A22.83,22.83,0,0,1,536.9,573.34Z"/><path d="M301.19,239.65c-77.36,0-140.3,62.94-140.3,140.3s62.94,140.31,140.3,140.31S441.5,457.32,441.5,380,378.56,239.65,301.19,239.65Zm0,245.61A105.31,105.31,0,1,1,406.5,380,105.42,105.42,0,0,1,301.19,485.26Z"/></g></svg>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-10 pr-0">
                    <div class="d-flex flex-column justify-content-center mt-1 mb-4">
                      <div class="d-flex align-items-center" style="gap: 30px;">
                        <div class="w-100" style="background-color: #FFEBF0; border-radius: 4px; border: 1px solid #bfbfbf; padding: 14px 25px;">
                          <h3 style="
                            font-size: 17px;
                            font-family: 'Poppins';
                            font-weight: 600;
                            color: #000000;
                            line-height: 1.2;
                            margin-bottom: 0;
                          ">
                            Desayuno, Día Libre.
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
               </div>

               <!-- Sugerencias por fecha (solo si existen) -->
               <!-- TODO: En el futuro, asignar sugerencias según su propio período cuando el endpoint provea esa info -->
               <ng-container *ngIf="day.dateSuggestions && day.dateSuggestions.length > 0">
                 <div class="row m-0">
                  <div class="col-2">
                    <div class="d-flex flex-column adjust-container-icon-line align-items-center"></div>
                  </div>

                  <div class="col-10 pr-0">
                   <div class="d-flex flex-column">
                     <usb-suggestions-item
                       class="d-flex justify-content-between align-items-start"
                       style="width: 100%"
                       [suggestions]="day.dateSuggestions"
                       [currencyAgency]="currencyAgency"
                       [currencies]="currencies"
                       [clientSetting]="getClientsSettingAppBooking"
                       [paymentAgencyActive]="paymentAgencyActive"
                       (reloadEmmit)="suggestionAdd()"
                     >
                     </usb-suggestions-item>
                   </div>
                  </div>
                 </div>
              </ng-container>
                <!-- Insurance FINALIZÓ en día libre -->
                <ng-container *ngIf="day._insurancesEnded && day._insurancesEnded.length > 0">
                  <div class="row m-0">
                    <div class="col-2 pl-0">
                      <div class="d-flex flex-column align-items-center adjust-container-icon-line">
                        <span class="icon-line">
                          <span class="container-icon d-flex justify-content-center align-items-center" style="background-color: #ffd9e0">
                            <svg version="1.1" id="outline" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 600 612.4" style="fill: #fe2e54; width: 30px; height: 30px; enable-background:new 0 0 600 612.4;" xml:space="preserve"> <g> <path d="M599.4,237.2c0,8.6,0,17.2,0,25.7c-0.8,7.1-1.5,14.3-2.6,21.3C585.6,355.8,550,412,490.2,452.9c-1.7,1.1-3.3,2.4-5.1,3.6 c1.1,1.2,1.9,2.1,2.7,2.9c22,22.9,21.8,54.1-0.6,76.7c-9.7,9.8-19.4,19.7-29.4,29.3c-17.7,16.9-38.2,28.7-62,34.7 c-9.2,2.3-18.6,3.7-27.9,5.5c-9.7,0-19.5,0-29.2,0c-0.9-0.3-1.8-0.8-2.7-0.9c-37.3-3.3-71.8-15.6-104.4-33.2 C162,534.3,105.8,482.1,60.8,417.7C35.3,381.2,15.5,341.9,5.9,298c-2.4-10.8-3.6-21.8-5.4-32.7c0-7.8,0-15.6,0-23.4 c0.4-1.9,0.9-3.7,1.1-5.6c2.7-28,11.5-53.9,29.5-75.5c13.7-16.4,28.7-31.8,44.6-46.2c19.5-17.7,49.3-16.2,68.8,1.6 c1.6,1.5,3.3,3,5.1,4.7c1.3-1.9,2.2-3.1,3-4.4c38.2-56.4,90.4-91.7,157.3-105.2c9.5-1.9,19.1-3,28.7-4.5c11.3,0,22.6,0,33.9,0 c1.3,0.3,2.6,0.8,3.9,0.9c28.4,2.2,55.7,9,81.3,21.5c74.5,36.3,120.7,94.9,137.2,176.4C597.1,216,598,226.7,599.4,237.2z M338.3,42.6c-4.5,0.5-8.2,0.9-11.8,1.4C262,54,212.6,86.9,177.9,142c-2.4,3.8-1.8,5.9,1.3,8.7c7.8,7.4,15.4,14.9,22.8,22.7 c19.6,20.7,19.6,51.6,0.1,72.4c-3.5,3.7-7.1,7.2-10.7,10.8c-8.9,8.9-13.5,19.8-12.7,32.2c0.6,9,2.2,18.2,5.2,26.8 c10.2,29.3,29,52.7,51.9,73c19.3,17.1,40.4,31.1,66,37.2c19.8,4.7,37.5,1.7,51.6-14.4c1.8-2,3.8-3.9,5.8-5.8 c21.8-21.1,53.3-21.1,75,0.1c7.1,6.9,14.2,13.9,21,21.1c2.9,3.1,5,3.6,8.8,1.2c47.1-29.3,78.4-70.5,93-124 c3.2-11.7,4.7-23.8,7.2-36.6c-16.4,0-31.3,0-46.5,0c0-11.9,0-23.3,0-35.1c15.3,0,30.3,0,45.2,0C556,126,462.5,46.6,373.4,43.6 c0,14.9,0,29.8,0,44.7c-12,0-23.4,0-35.1,0C338.3,73.1,338.3,58.3,338.3,42.6z M347.9,570.5c38.8,0.2,66.3-11.1,90.2-34.8 c8-8,16-16,24-24c9.4-9.4,9.4-19.1-0.1-28.6c-16.5-16.6-33.1-33.1-49.6-49.6c-11.5-11.5-19.9-11.5-31.4,0.1 c-8.8,8.9-17.9,17.3-29.6,22.4c-20.9,9.1-42.4,9.5-63.4,2.3c-67.6-23.2-113.5-69.2-138.7-135.7c-7.5-19.9-8.4-40.7-1.5-61.3 c4.9-14.5,14.5-25.6,25.2-36c11.5-11.2,11.4-19.9-0.1-31.4c-16.7-16.7-33.4-33.4-50.1-50c-9.1-9-18.5-8.9-27.7,0 c-8.5,8.3-16.8,16.9-25.2,25.2c-23,22.7-33.9,50.5-34.1,82.5c-0.2,33.4,9.2,64.8,24,94.3c44.2,88.2,110.7,154.7,198.5,199.5 C287.8,560.7,319.3,570.1,347.9,570.5z"/> <path d="M432,185.7c0,27,0,53,0,79.6c4.9,0,9.3,0,14,0c0,8.6,0,16.7,0,25.4c-4.7,0-9,0-14.1,0c0,8.5,0,16.4,0,24.7 c-9.1,0-17.5,0-26.5,0c0-8.1,0-16,0-24.5c-17.2,0-33.9,0-50.9,0c-0.6-6.7-1.2-12.5,2.3-18.4c15.9-27.2,31.5-54.6,47-82 c2-3.6,4.2-4.9,8.2-4.7C418.4,186,424.8,185.7,432,185.7z M405,239.2c-0.3-0.1-0.6-0.2-0.9-0.3c-4.7,8.5-9.5,17-14.5,26 c5.8,0,10.6,0,15.5,0C405,256,405,247.6,405,239.2z"/> <path d="M307.2,290.7c14,0,27.4,0,41.1,0c0,8.5,0,16.3,0,24.6c-27.6,0-54.9,0-82.5,0c-0.9-7.6-0.9-14.2,4.5-20.7 c14.4-17.4,28-35.5,41.8-53.3c4.3-5.6,8.3-11.3,7.8-19c-0.4-7.1-3.3-11.2-9.2-12.3c-6.9-1.3-12.8,1.4-15.2,7.8 c-1.5,3.9-1.9,8.2-3,12.9c-7.5-1.4-14.9-2.6-22.3-4.3c-1.1-0.2-2.4-2.4-2.4-3.6c-0.4-22.7,18.9-39.6,43.5-38.3 c22.1,1.1,37.3,19.3,34.9,41.8c-1.1,10.2-5.2,19-11.5,27c-9.1,11.7-18.1,23.5-27.1,35.2C307.6,288.9,307.6,289.3,307.2,290.7z"/> </g> </svg>
                          </span>
                        </span>
                      </div>
                    </div>
                    <div class="col-10 pr-0">
                      <div class="d-flex flex-column w-100">
                        <!-- Collapsible Header -->
                        <div class="insurance-collapsible-header"
                            style="background-color: #ffd9e0; border: 1px solid #ababab; border-radius: 10px; height: 90px; cursor: pointer; display: flex; align-items: center; justify-content: space-between; padding: 0 25px;">
                          <div class="d-flex align-items-center" style="gap: 15px;">
                            <h3 style="font-size: 18px; font-family: 'Lato'; font-weight: 600; color: #000000; margin-bottom: 0;">
                              Tu asistencia al viajero <span style="color: #fe2e54; font-weight: 700;">finalizó</span>
                            </h3>
                            <div class="d-flex align-items-center" style="gap: 10px;">
                              <ng-container *ngFor="let insurance of day._insurancesEnded">
                                <div class="d-flex align-items-center justify-content-center" style="background-color: #FFFFFF; border: 1px solid #ababab; border-radius: 50%; width: 40px; height: 40px; padding: 5px;">
                                  <img style="width: 100%; height: 100%; object-fit: contain;" [src]="insurance?.item?.provider?.logo" alt="" />
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>

        <!-- Check-out Footer -->
        <div class="row m-0" style="margin-top: 50px !important;">
          <div class="col-2 pl-0">
            <div class="d-flex flex-column adjust-container-icon-line align-items-center">
              <span class="icon-line">
                <span class="container-icon check-out d-flex justify-content-center align-items-center">
                  <svg version="1.1" id="outline" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 600 612.4" style="width: 30px; fill: #fe2e54;enable-background:new 0 0 600 612.4;" xml:space="preserve"> <path d="M583.3,578h-59.1V164.1c0-13.1-10.6-23.7-23.7-23.7h-54.1V93c0-13.1-10.6-23.7-23.7-23.7h-28V23.2 c0-13.1-10.6-23.7-23.7-23.7H229c-13.1,0-23.7,10.6-23.7,23.7v46.1h-28c-13.1,0-23.7,10.6-23.7,23.7v47.4H99.5 c-13.1,0-23.7,10.6-23.7,23.7V578H16.6c-9.7,0-17.5,7.8-17.5,17.5S7,613,16.6,613h566.7c9.7,0,17.5-7.8,17.5-17.5S593,578,583.3,578 L583.3,578z M240.3,34.5h119.5v34.8H240.3V34.5z M188.6,104.3h222.8v36.1H188.6V104.3z M282.5,578h-72.6V467.3h72.6V578z M317.5,578 V467.3h72.6V578H317.5z M425.1,578V456c0-13.1-10.6-23.7-23.7-23.7H198.6c-13.1,0-23.7,10.6-23.7,23.7v122h-64.1V175.4h378.4V578 H425.1z"/> <path d="M192.9,229.8c-9.7,0-17.5,7.8-17.5,17.5v27.5c0,9.7,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5v-27.5 C210.4,237.6,202.5,229.8,192.9,229.8z"/> <path d="M264.3,229.8c-9.7,0-17.5,7.8-17.5,17.5v27.5c0,9.7,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5v-27.5 C281.8,237.6,273.9,229.8,264.3,229.8z"/> <path d="M335.7,229.8c-9.7,0-17.5,7.8-17.5,17.5v27.5c0,9.7,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5v-27.5 C353.2,237.6,345.4,229.8,335.7,229.8z"/> <path d="M407.1,229.8c-9.7,0-17.5,7.8-17.5,17.5v27.5c0,9.7,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5v-27.5 C424.6,237.6,416.8,229.8,407.1,229.8z"/> <path d="M192.9,324.3c-9.7,0-17.5,7.8-17.5,17.5v27.5c0,9.7,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5v-27.5 C210.4,332.1,202.5,324.3,192.9,324.3C192.9,324.3,192.9,324.3,192.9,324.3z"/> <path d="M264.3,324.3c-9.7,0-17.5,7.8-17.5,17.5v27.5c0,9.7,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5v-27.5 C281.8,332.1,274,324.3,264.3,324.3C264.3,324.3,264.3,324.3,264.3,324.3z"/> <path d="M335.7,324.3c-9.7,0-17.5,7.8-17.5,17.5c0,0,0,0,0,0v27.5c0,9.7,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5v-27.5 C353.2,332.1,345.4,324.3,335.7,324.3z"/> <path d="M407.1,324.3c-9.7,0-17.5,7.8-17.5,17.5c0,0,0,0,0,0v27.5c0,9.7,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5v-27.5 C424.6,332.1,416.8,324.3,407.1,324.3z"/> </svg>
                </span>
              </span>
            </div>
          </div>

          <div class="col-10 pr-0">
            <div class="d-flex flex-column justify-content-center mt-1 h-100">
              <p style="font-family: &quot;Rubik&quot;, serif; font-size: 18px; font-weight: 600; margin-bottom: 0px">
                <span style="color: #fe2e54; font-weight: bold">Check-out</span> Fin de los Servicios
              </p>
            </div>
          </div>
        </div>
       </div>
     </ng-container>
   </div>

  <!-- File And Suggestions (sidebar) -->
  <div class="d-flex flex-column align-items-center" style="width: 30%">
    <div class="row justify-content-end mb-3 w-100">
      <div class="d-flex flex-column w-100">
        <!-- Header -->
        <div
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          style="border-top-left-radius: 12px; border-top-right-radius: 12px"
          class="py-3 mb-3"
        >
          <p class="mb-0 text-center" style="font-family: &quot;Poppins&quot;; font-size: 32.48px; font-weight: 700; color: #000000">
            File
          </p>
        </div>

        <!-- Body -->
        <div
          class="d-flex flex-column justify-content-center align-items-start p-5"
          style="background-color: #ffffff; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px"
        >
          <p class="mb-0" style="font-family: &quot;Muli&quot;, sans-serif; font-size: 20px; font-weight: 500">Total Neto</p>

          <!-- Price -->
          <div class="d-flex align-items-center w-100 pb-4" style="gap: 5px; border-bottom: 1px solid #dad9d7">
            <p class="mb-0" style="font-family: &quot;Muli&quot;, sans-serif; font-size: 25px; font-weight: 600; line-height: 1">
              {{ currencyAgency.code }}
            </p>
            <div class="d-flex">
              <!-- {{ totalNetPriceBooking > 0 ? totalNetPriceBooking : totalNetPriceBookingFreeTax | number:'1.2-2'}}</p> -->
              <p class="mb-0" style="font-family: &quot;Muli&quot;, sans-serif; font-size: 25px; font-weight: 600; line-height: 1">
                {{ (getTotalTarifa() ? getTotalTarifa() : 0) | number: "1.2-2" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-end pt-4 mb-3" style="gap: 10px">
            <img width="40" height="35" src="../../../../../assets/icons/search-result/BLICKOIS-01.svg" />

            <div class="d-flex flex-column" style="gap: 2px">
              <span style="font-size: 14.95px; font-family: &quot;Rubik&quot;; font-weight: 400; line-height: 1; text-transform: none">
                Blickoins acumulados
              </span>

              <span style="color: #ffc039; font-size: 16.1px; font-weight: 600; line-height: 1; font-family: &quot;Muli&quot;, sans-serif">
                {{ (totalBlickoins ? totalBlickoins : 0) | number: "1.2-2" }} BKS -
                {{ (totalCreditBlickoins ? totalCreditBlickoins : 0) | number: "1.2-2" }} USD
              </span>
            </div>
          </div>

          <!-- Button -->
          <div class="d-flex w-100" style="gap: 0.5em">
            <!-- <button -->
            <!--   type="button" -->
            <!--   (click)="DownloadItineraryQuote(actualItinerary.id)" -->
            <!--   class="btn rounded btn-block mt-2 px-2 mx-auto w-50" -->
            <!--   style="font-family: &quot;Rubik&quot;, serif; font-weight: 600" -->
            <!--   [ngStyle]="{ -->
            <!--     'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1, -->
            <!--     color: styleSidebar?.color -->
            <!--   }" -->
            <!-- > -->
            <!--   Cotización -->
            <!-- </button> -->
            <button
              type="button"
              (click)="goToReserve()"
              class="btn rounded btn-block mt-2 px-2 mx-auto w-100"
              style="font-family: &quot;Muli&quot;, sans-serif; font-size: 20px; font-weight: 600"
              [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>

    <usb-suggestion
      *ngIf="actualItinerary"
      [actualItinerary]="actualItinerary"
      [getClientsSettingAppBooking]="getClientsSettingAppBooking"
      (suggestionsCategories)="suggestionsCategories($event)"
      [currencies]="currencies"
      [currencyAgency]="currencyAgency"
      [paymentAgencyActive]="paymentAgencyActive"
      (reloadEmmit)="reloadEmmit()"
      style="max-width: 100%;"
    >
    </usb-suggestion>
  </div>
</ng-template>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fa1a1a" type="line-scale">
  <p style="color: white">Loading...</p>
</ngx-spinner>
